import { FeatureFlags } from './types';
import axios from 'axios';

export const fetchFeatureFlagsFromAppConfig = async (appConfigConfiguration: string): Promise<FeatureFlags> => {
  const url = `http://localhost:2772/${appConfigConfiguration}`;
  const response = await axios.get<FeatureFlags>(url);
  return response.data;
};
